export default __webpack_public_path__ + "static/iconography-image-a-ed6394e9c048d1c16301c34304114fbc.png";